<template>
  <div class="row mt-5">
    <div class="col-md-3">
      <h4 class="text-primary">購物須知</h4>
    </div>
    <div class="col-md-9">
      <p>每次購物滿 3,000 元以上免運費，未達 3,000 元，需加付 230 元運費，訂單完成後，將在 1 ~ 3 個工作天內出貨。</p>
    </div>
    <div class="col-md-3 mt-5">
      <h4 class="text-primary">退貨需知</h4>
    </div>
    <div class="col-md-9 mt-md-5">
      <p>在 FITNESS KITCHEN 官網購物，享有商品到貨日起 10 天猶豫期，猶豫期內，可無條件退費。猶豫期並非試用期，所以，您所退回的商品必須是包裝完整、保存良好的狀態。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
